import { FC, useMemo } from 'react'

import RFFFields from '../../react-final-form-fields'
import { validateRequired, validateMaxSymbols, composeValidators } from '../../../../util/validation'
import { nameofFactory, toOptions } from '../../../../util'

import { SafetyCaseFormFieldsProps, ISafetyCaseValues } from './safety-case-form-types'
import { useSafetyCaseStatusesQuery } from '../../../../services'
import Tags from '../../../../features/safety-case/safety-case-page/tags'

const validateMaxSymbols500 = validateMaxSymbols(500, 'Notes must not exceed 500 characters')
const validateMaxSymbols100 = validateMaxSymbols(100, 'Action must not exceed 100 characters')

const nameof = nameofFactory<ISafetyCaseValues>()

const nameLabel = 'Case Title'
const descriptionLabel = 'Internal Summary'
const statusLabel = 'Status'

const SafetyCaseFormFields: FC<SafetyCaseFormFieldsProps> = props => {
  const { disabled, baseStatus, additionalOptions, values, addSelectedTagIds, isViewMode } = props

  const statusesQuery = useSafetyCaseStatusesQuery({ activeOnly: true, baseStatus })

  const statusesOptions = useMemo(
    () =>
      additionalOptions?.getStatusesOptions
        ? additionalOptions?.getStatusesOptions(toOptions(statusesQuery?.data), values)
        : toOptions(statusesQuery?.data),
    [statusesQuery?.data, additionalOptions, values],
  )

  return (
    <>
      <RFFFields.Input
        name={nameof('name')}
        label={nameLabel}
        placeholder="Enter the short name for this case (e.g., 'Gate Area Trip Case')"
        disabled={disabled}
        isViewMode={isViewMode}
        validate={composeValidators(validateRequired, validateMaxSymbols100)}
      />

      <RFFFields.Textarea
        name={nameof('description')}
        label={descriptionLabel}
        placeholder="Summarize the case in your own words. Use this to interpret or clarify what was reported for internal tracking."
        disabled={disabled}
        isViewMode={isViewMode}
        validate={validateMaxSymbols500}
      />

      <RFFFields.Select
        name={nameof('statusId')}
        label={statusLabel}
        placeholder={'Select ' + statusLabel}
        options={statusesOptions}
        isViewMode={isViewMode}
        disabled={statusesQuery?.isFetching || disabled}
      />

      {addSelectedTagIds && <Tags addSelectedTagIds={addSelectedTagIds} />}
    </>
  )
}

export default SafetyCaseFormFields
